(() => {
  const nav = document.querySelector('[data-site-breadcrumbs]');
  if (!nav) return;
  const key = 'iki-breadcrumb-page';
  const current = nav.querySelector('[data-breadcrumb-current]');
  const allowed = url => url.origin === location.origin && /^\/(collections|search|blogs|pages|cart)(\/|$)/.test(url.pathname);
  try {
    const previous = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (nav.dataset.pageType === 'product' && document.referrer) {
      const referrer = new URL(document.referrer);
      if (allowed(referrer)) {
        const previousUrl = previous?.url ? new URL(previous.url, location.origin) : null;
        const matched = previousUrl?.pathname === referrer.pathname;
        const label = matched ? previous.label : referrer.pathname.startsWith('/collections/')
          ? referrer.pathname.split('/')[2].replace(/-/g, ' ').replace(/^./, c => c.toUpperCase())
          : referrer.pathname === '/cart' ? 'Your bag'
          : referrer.pathname === '/search' ? 'Search'
          : referrer.pathname.startsWith('/blogs/') ? 'Journal' : 'Previous page';
        const parent = nav.querySelector('[data-breadcrumb-parent] a');
        if (parent && label) {
          parent.href = matched ? previousUrl.pathname + previousUrl.search : referrer.pathname + referrer.search;
          parent.textContent = label === 'Home' ? 'Home collection' : label;
        }
      }
    }
    sessionStorage.setItem(key, JSON.stringify({ url: location.pathname + location.search, label: current.dataset.fullTitle || current.textContent.trim() }));
  } catch {
    // Server-rendered hierarchy remains available when storage is disabled.
  }
})();
